module.exports = "<span class=\"completer-list-item-holder\" [ngClass]=\"{'completer-title': type === 'title', 'completer-description': type === 'description'}\" >\n  <span class=\"completer-list-item\" *ngFor=\"let part of parts\" [ngClass]=\"part.isMatch ? matchClass : null\">{{part.text}}</span>\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/typescripts/pro/autocomplete/components/completer-list-item.component.html
// module id = ./src/app/typescripts/pro/autocomplete/components/completer-list-item.component.html
// module chunks = main